<template>
  <button :type="nativeType" @click="handleClick" class="my-button-box">
    <slot></slot>
  </button>
</template>
<script>
// <Button5></Button5>

export default {
  name: 'Button5',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

//
.my-button-box{
  height: 40px;
  line-height: 40px;
  border: none;
  background:#ffefe5;
  border: 1px solid #FF6600;
  padding: 0 21px;
  border-radius: 4px;
  color: #FF6600;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  &:hover{
    // border: 1px solid #409ee9;
  }
}
</style>
